export default theme => ({
  buttonsFadeIn: {
    minWidth: "120px",
    width: "100%"
  },
  uploadButton: {
    position: "relative",
    minHeight: 220
  },
  uploadLabel: {
    position: "absolute",
    top: "50%",
    left: "50%",
    color: theme.palette.background.main,
    textAlign: "center",
    transform: "translate(-50%, -50%);"
  },
  uploadOverlay: {
    position: "absolute",
    width: "100%",
    border: "4px dashed",
    borderColor: theme.palette.background.main,
    borderRadius: theme.spacing(1),
    minHeight: 220
  },
  uploadInput: {
    position: "absolute",
    width: "100%",
    minHeight: 220,
    zIndex: 2,
    opacity: 0
  }
});
